import config from 'config/config';

export default {
  /* istanbul ignore next */
  debounce(func, wait, immediate, ...args) {
    let timeout;

    /* istanbul ignore next */
    return () => {
      const context = this;
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },

  generateHash() {
    const ALPHABET = '23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ';
    const ID_LENGTH = 9;

    let rtn = '';

    for (let i = 0; i < ID_LENGTH; i += 1) {
      rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }

    return rtn;
  },

  scrollToTop() {
    if (window && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },

  storageAvailable(type) {
    try {
      const storage = window[type];
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  },

  localStorageAvailable() {
    return this.storageAvailable('localStorage');
  },
};

export const getCookieValue = (cookieName) => {
  const b = document.cookie.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
};

export const getAuthTokens = () => {
  const cookieValue = getCookieValue(config.AUTH_COOKIE_NAME);
  const tokens = {};
  let parts;
  if (!cookieValue) {
    return false;
  }
  cookieValue.split('&').forEach((chunk) => {
    parts = chunk.split('=');
    tokens[parts[0]] = parts[1];
  });
  return tokens;
};

export const initLogError = () => {
  if (window.GG && window.GG.Raygun) {
    const raygun = window.GG.Raygun;
    raygun.init(config.DIAGNOSTICS_ENDPOINT, {
      allowInsecureSubmissions: true,
      ignoreAjaxAbort: true,
      debugMode: Boolean(config.LOCAL),
      ignore3rdPartyErrors: false,
    }).attach();

    raygun.setVersion(config.APP_VERSION, config.APP_NAME);
  }
};

export const logError = (error, customData) => {
  if (window.GG && window.GG.Raygun) {
    window.GG.Raygun.send(error, customData);
  }
};

export const parseJWT = (jwt, _logError = logError) => {
  let parsedJWT = {};
  try {
    parsedJWT = JSON.parse(window.atob(jwt.split('.')[1]));
  } catch (err) {
    err.jwt = jwt;
    _logError(err);
  }
  return parsedJWT;
};

export const getUserGUID = (jwt, _parseJWT = parseJWT) => _parseJWT(jwt).sub;



// WEBPACK FOOTER //
// ./utils/tools/tools.js